import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GlobalErrorHandlerService } from './global-error-handler.service';

import { ExamGroup } from '../exam-group/exam-group';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})
export class ExamGroupService {

  private examGroupUrl = 'api/exam_groups';

  constructor(
    private http: HttpClient,
    private errorHandler: GlobalErrorHandlerService
  ) {}

  getAll(): Observable<ExamGroup[]> {
    return this.http
      .get<ExamGroup[]>(this.examGroupUrl, httpOptions)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }
}
